import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule, Mail, Phone, MapPin, Clock, Send, MessageCircle, HelpCircle, ChevronDown } from 'lucide-angular';
import { Subscription } from 'rxjs';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CartService } from '../../services/cart.service';
import { CommonExternalModule } from '../../common/common-external-module';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonExternalModule, HeaderComponent, FooterComponent],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.css',
})
export class ContactComponent implements OnInit, OnDestroy {
  cartCount = 0;
  submitted = false;
  openFaq: number | null = null;
  private cartSubscription!: Subscription;

  formData = {
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  };

  contactInfo = [
    { icon: 'mail', title: 'Email Us', value: 'info@capitalfood.in', link: 'mailto:info@capitalfood.in' },
    { icon: 'phone', title: 'Call Us', value: '+91 637 095 2176', link: 'tel:+916370952176' },
    { icon: 'map-pin', title: 'Head Office', value: 'H-21, Mancheswar Industrial Estate, Bhubaneswar- 751010', link: null },
    { icon: 'clock', title: 'Working Hours', value: 'Mon-Sat 11:00 AM - 06:00 PM', link: null }
  ];

  faqs = [
    { question: 'How do I track my order?', answer: 'You can track your order in real-time through the Capital Food app or website. Simply go to "My Orders" and click on the active order to see its live status.' },
    { question: 'What is the delivery time?', answer: 'Our average delivery time is 25-35 minutes. However, this may vary based on your location, restaurant preparation time, and traffic conditions.' },
    { question: 'How do I apply a coupon code?', answer: 'You can apply coupon codes at checkout. Simply enter the code in the "Apply Coupon" field and click "Apply". The discount will be automatically applied to your order.' },
    { question: 'What is your refund policy?', answer: "We offer full refunds for cancelled orders before preparation begins. For quality issues, please contact us within 2 hours of delivery with photos, and we'll process your refund or provide a replacement." },
    { question: 'How do I become a partner restaurant?', answer: 'To partner with Capital Food, please visit our "Partner with Us" page and fill out the application form. Our team will review your application and get back to you within 48 hours.' }
  ];

  constructor(private cartService: CartService) { }

  ngOnInit() {
    this.cartSubscription = this.cartService.cart$.subscribe(() => {
      this.cartCount = this.cartService.getCartCount();
    });
  }

  ngOnDestroy() {
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }
  }

  handleSubmit() {
    this.submitted = true;
    setTimeout(() => {
      this.formData = { name: '', email: '', phone: '', subject: '', message: '' };
      this.submitted = false;
    }, 3000);
  }

  toggleFaq(index: number) {
    this.openFaq = this.openFaq === index ? null : index;
  }
}
